export default __webpack_public_path__ + "static/media/expand_down.7f1c6f0e.svg";